/** The workspace a page is working in, from the /w/:ws route. */
import { createContext, useContext } from "react";
import type { Workspace } from "@sable/api-contract";
import type { Permission } from "@sable/domain";

export const WorkspaceContext = createContext<Workspace | null>(null);

export function useWs(): Workspace {
  const ws = useContext(WorkspaceContext);
  if (!ws) throw new Error("useWs outside a workspace route");
  return ws;
}

export function useCan(permission: Permission): boolean {
  return useWs().permissions.includes(permission);
}

/** Path inside the current workspace. */
export function wsPath(ws: { id: string }, path: string): string {
  return `/w/${ws.id}${path.startsWith("/") ? path : `/${path}`}`;
}
